import { useEffect, useState } from 'react';

const numberFormatter = new Intl.NumberFormat('fr-FR');

function formatCount(value) {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '…';
  }
  return numberFormatter.format(value);
}

function indexedStoreLabel(count) {
  return typeof count === 'number' && Number.isFinite(count) && count === 1
    ? 'online shop'
    : 'online shops';
}

function parseStat(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function newProductLabel(count) {
  return count === 1 ? 'new product' : 'new products';
}

function priceChangeLabel(count) {
  return count === 1 ? 'price change' : 'price changes';
}

export function SearchStatsLine() {
  const [stats, setStats] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/stats.php')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (cancelled) {
          return;
        }
        const products = Number(data?.products);
        const stores = Number(data?.stores);
        if (!Number.isFinite(products) || !Number.isFinite(stores)) {
          throw new Error('invalid stats payload');
        }
        setStats({
          products,
          stores,
          newProducts: parseStat(data?.t1),
          priceChanges: parseStat(data?.t4),
        });
      })
      .catch(() => {
        if (!cancelled) {
          setFailed(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) {
    return null;
  }

  return (
    <div className="landing-stats">
      <p className="landing-stats__line">
        Search{' '}
        <span className="landing-stats__num">{formatCount(stats?.products)}</span>{' '}
        products from{' '}
        <span className="landing-stats__num">{formatCount(stats?.stores)}</span>{' '}
        {indexedStoreLabel(stats?.stores)}{' '}
        in Malta.
      </p>
      <p className="landing-stats__line landing-stats__line--muted">
        <span className="landing-stats__num">{formatCount(stats?.newProducts)}</span>{' '}
        {newProductLabel(stats?.newProducts ?? 0)} and{' '}
        <span className="landing-stats__num">{formatCount(stats?.priceChanges)}</span>{' '}
        {priceChangeLabel(stats?.priceChanges ?? 0)} in the last week
      </p>
    </div>
  );
}
